import axios from './axios'
import config from '../config'

export default {
    getUserInfo() {
        return axios({
            url: config.backendUrl + '/user-profile',
            method: 'GET'
        })
    },
    updateCurrentUserInfo(data) {
        return axios({
            url: config.backendUrl + '/user-profile',
            method: 'PUT',
            data
        })
    },
    updatePwd({data}) {
        return axios({
            url: config.backendUrl + '/user-profile/update-pwd',
            method: 'PUT',
            data
        })
    },
    getVisibleUserGroups() {
        return axios({
            url: config.backendUrl + '/user-profile/visible-user-groups',
            method: 'GET'
        })
    },
    listVisibleUsers(params) {
        return axios({
            url: config.backendUrl + '/user-profile/visible-users',
            method: 'GET',
            params
        })
    },
    listUsers(params) {
        return axios({
            url: config.backendUrl + '/common/admin/users',
            method: 'GET',
            params
        })
    },
    async fetchCreatorAndEditor(data, creatorProp='creator', editorProp='editor') {
        const map = {}
        const ids = []
        for (const item of data) {
            if (item[creatorProp]) {
                if(typeof item[creatorProp] === 'object') {
                    ids.push(item[creatorProp].id)
                } else {
                    ids.push(item[creatorProp])
                }
            }
            if (item[editorProp]) {
                if(typeof item[editorProp] === 'object') {
                    ids.push(item[editorProp].id)
                } else {
                    ids.push(item[editorProp])
                }
            }
        }
        if (ids.length === 0) {
            return
        }
        const response = await axios({
            url: config.backendUrl + '/common/admin/users',
            method: 'GET',
            params: {ids, page: 0, size: ids.length}
        })
        const users = response.data.content
        for (const user of users) {
            map[user.id] = user
        }
        for (const item of data) {
            if (item[creatorProp]) {
                if(typeof item[creatorProp] === 'object') {
                    item[creatorProp] = map[item[creatorProp].id]
                } else {
                    item[creatorProp] = map[item[creatorProp]]
                }
            }
            if (item[editorProp]) {
                if(typeof item[editorProp] === 'object') {
                    item[editorProp] = map[item[editorProp].id]
                } else {
                    item[editorProp] = map[item[editorProp]]
                }
            }
        }
    },
    async fetchUserProps(data, ...props) {
        const map = {}
        const ids = []
        for (const item of data) {
            for(const prop of props){
                if (item[prop]) {
                    ids.push(item[prop].id)
                }
            }
        }
        if (ids.length === 0) {
            return
        }
        const response = await axios({
            url: config.backendUrl + '/common/admin/users',
            method: 'GET',
            params: {ids, page: 0, size: ids.length}
        })
        const users = response.data.content
        for (const user of users) {
            map[user.id] = user
        }
        for (const item of data) {
            for(const prop of props){
                if (item[prop]) {
                    item[prop] = map[item[prop].id]
                }
            }
        }
    },
    addUser(data) {
        return axios({
            url: config.backendUrl + '/common/admin/users',
            method: 'POST',
            data
        })
    },
    updateUser({id, data}) {
        return axios({
            url: config.backendUrl + '/common/admin/users/' + id,
            method: 'PUT',
            data
        })
    },
    getUser(id) {
        return axios({
            url: config.backendUrl + '/common/admin/users/' + id,
            method: 'GET'
        })
    },
    deleteUser(id) {
        return axios({
            url: config.backendUrl + '/common/admin/users/' + id,
            method: 'DELETE'
        })
    },
    checkUserName(name) {
        return axios({
            url: config.backendUrl + '/common/admin/users/check-name',
            method: 'GET',
            params: {name}
        })
    },
    resetPwd({id, data}) {
        return axios({
            url: config.backendUrl + '/common/admin/users/' + id + '/reset-pwd',
            method: 'PUT',
            data
        })
    }
}
